export const TOGGLE_CONTACT_MODAL = 'TOGGLE_CONTACT_MODAL';
export const OPEN_CONTACT_MODAL = 'OPEN_CONTACT_MODAL';

export const toggleContactModal = () => async (dispatch) => {
  dispatch({
    type: TOGGLE_CONTACT_MODAL,
  });
};

export const openContactModal = () => async (dispatch) => {
  dispatch({
    type: OPEN_CONTACT_MODAL,
  });
};
